import { Box, GridItem, SimpleGrid } from '@chakra-ui/react';
import { Helmet } from 'react-helmet-async';
import ContainerBox from 'src/components/container-box/ContainerBox';
import NavigationLink from 'src/components/top-bar/NavigationLink';
import TopBar from 'src/components/top-bar/TopBar';
import colors from 'src/theme/colors';
import Page from 'src/components/page/Page';
import ReviewsSection from 'src/pages/signup/reviews/ReviewsSection';
import SignupForm from 'src/pages/signup/form/SignupForm';

export default function Signup() {
  return (
    <Page title="Sign Up" pb="10px" minW="100%">
      <Helmet>
        <style>{`body {
          background-color: ${colors.podcastShade100};
        }
      `}</style>
      </Helmet>
      <TopBar zIndex={4}>
        <Box>
          <NavigationLink to="/login">Login</NavigationLink>
          <NavigationLink isActive>Register</NavigationLink>
        </Box>
      </TopBar>
      <SimpleGrid
        columns={{ sm: 2, md: 6, lg: 12 }}
        gapX={{ sm: 20, md: 30 }}
        rowGap={['31px', '49px']}
        maxW={{ md: '510px', lg: '690px', xl: '930px', '2xl': '1110px' }}
        minW="320px"
        mx="auto"
        mt={{ sm: 0, md: '30px', xl: '42px', '2xl': '60px' }}
        pb="46px"
      >
        <GridItem colSpan={{ sm: 2, md: 6, lg: 12, xl: 8 }}>
          <ContainerBox bgColor={colors.white} height="unset">
            <SignupForm />
          </ContainerBox>
        </GridItem>
        <GridItem
          colSpan={{ sm: 2, md: 4, lg: 12, xl: 4, '2xl': 4 }}
          colStart={{ sm: 0, md: 2, lg: 0 }}
        >
          <ReviewsSection />
        </GridItem>
      </SimpleGrid>
    </Page>
  );
}
